export interface AuthState {
    token: string | null | 'NOT_SET',
    remember: boolean
}

export const AUTH_FEATURE_KEY = 'auth';